import React from 'react'

const GameModeConfigSeparator = ({
    direction = 'horizontal'
}: {
    direction?: 'horizontal' | 'vertical'
}) => {
    return (
        <div className={`${direction === 'horizontal' ? 'border-t border-t-[#161616] border-b border-b-[#585858] h-[3px]' : 'border-l border-l-[#161616] border-r border-r-[#585858] w-[3px]'}`}></div>
    )
}

export default GameModeConfigSeparator